export enum TAGS {
  COMPANIES = 'COMPANIES',
  COMPANY = 'COMPANY',
  DRAFT_COMPANIES = 'DRAFT_COMPANIES',
  DRAFT_COMPANY = 'DRAFT_COMPANY',
  COMPANY_HISTORY = 'COMPANY_HISTORY',
  COMPANY_HISTORY_CHANGE = 'COMPANY_HISTORY_CHANGE',
  USERS = 'USERS',
  USER = 'USER',
  DELETED_COMPANIES = 'DELETED_COMPANIES',
  EXTERNAL_USERS = 'EXTERNAL_USERS',
}
